import { useQuery } from "@tanstack/react-query";
import { IntegrationLogSearchParams } from "@/types";
import { queryEvents as queryIntegrationLogs } from "@/apis/integration/log";

export function useIntegrationLogs(query: IntegrationLogSearchParams) {
  return useQuery({
    queryKey: ["integration-logs", JSON.stringify(query)],
    queryFn: () => queryIntegrationLogs(query),
    placeholderData: (previousData) => previousData,
  });
}
